<div [class.fullscreen]="isFullScreen">
    <div class="ageing-bar-chart-component">
        <div class="upper-chart-heading">
            <div class="ltms-widget-title">
                {{ title}}
                <div class="upper-chart-discription ltms-description">
                    {{ lowerChartDiscription }}
                </div>
            </div>
            <div class="right-upper-chart-options">
                <!-- <app-ltms-widget-tools [config]='widgetConfig' [elementId]="widgetConfig.elementId" (onViewChange)="onViewChange($event)" (onTrendTypeChange)="onTrendTypeChange($event)"></app-ltms-widget-tools> -->
                <app-score-widget [config]="scoreWidget('barChart')" (onFullscreenClick)="onFullScreen($event)"
                    (onTrendClick)="onTrendTypeChange($event)" (onDownloadClick)="onDownload()"
                    (onChartTypeChange)="onViewChange($event)"></app-score-widget>
            </div>
        </div>
        <!-- <div class="upper-chart-discription ltms-description">
    {{ lowerChartDiscription }}
</div> -->
        <div *ngIf="isDataAvailable && isDataLoaded">
            <div class="bar-chart">
                <app-ltms-bar-chart-view [config]="chartData" [componentId]="chartId"
                    (onSelect)="onChartClick($event)"></app-ltms-bar-chart-view>
            </div>
        </div>
        <div *ngIf="!isDataAvailable && isDataLoaded">
            <app-ltms-error [code]="errorCode"></app-ltms-error>
        </div>
        <div class="data-details-loader" *ngIf="isDataLoaded == false">
            <app-ltms-loader></app-ltms-loader>
        </div>
    </div>
</div>